import React from 'react';
import { PractitionerActivityCardComponent } from '../../../components/Cards';

const PractitionerActivityCard = () => <PractitionerActivityCardComponent />;

export default PractitionerActivityCard;
